import React, { useState } from 'react';
import { Upload, Button, Typography, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { uploadFile } from '../../reducers/uploads/resources';

const { Text } = Typography;

export default function UploadLogo({ bot }) {
    const [preview, setPreview] = useState('');

    const doUpload = async (file) => {
        if (!bot?.id) {
            message.warning('Select a bot first.');
            return Upload.LIST_IGNORE;
        }
        const form = new FormData();
        form.append('file', file);
        form.append('botid', bot.id);
        try {
            await uploadFile(form);
            const reader = new FileReader();
            reader.onloadend = () => setPreview(reader.result);
            reader.readAsDataURL(file);
            message.success('Logo uploaded');
        } catch (err) {
            console.error(err);
            message.error('Upload failed');
        }
        return false; // prevent antd default upload
    };

    return (
        <div>
            <Text strong style={{ display: 'block', marginBottom: 8 }}>Upload logo</Text>
            <Upload showUploadList={false} beforeUpload={doUpload} accept="image/*">
                <Button icon={<UploadOutlined />}>Choose image</Button>
            </Upload>
            {preview && (
                <img
                    src={preview}
                    alt="Logo preview"
                    style={{ display: 'block', marginTop: 8, maxWidth: '100%', borderRadius: 6 }}
                />
            )}
        </div>
    );
}
